import axios from "axios";
import { Environment } from "../environment/environment";
import { persistor } from "./store";



//Đăng ký/Đăng nhập/User
import {
    loginFailed, loginStart, loginSuccess,
    logoutFailed, logoutStart, logoutSuccess
} from "./authSlice";
import {
    getCustomersStart,
    getCustomersSuccess,
    getCustomersFailed,
    getCustomerStart,
    getCustomerSuccess,
    getCustomerFailed,
    createCustomerStart,
    createCustomerSuccess,
    createCustomerFailed,
    updateCustomerStart,
    updateCustomerSuccess,
    updateCustomerFailed,
    deleteCustomerStart,
    deleteCustomerSuccess,
    deleteCustomerFailed,
} from "./customerSlice";
import {
    getUsersStart,
    getUsersSuccess,
    getUsersFailed,
    createUserStart,
    createUserSuccess,
    createUserFailed,
} from "./userSlice";

import { getDataTiktokStart, getDataTiktokFailed, getDataTiktokSuccess } from "./dataTiktok"
import { getDataFacebookStart, getDataFacebookSuccess, getDataFacebookFailed } from "./dataFacebook"
// Slice Post Page
axios.defaults.baseURL = `${Environment.BASE_API}`;

//ĐĂNG NHẬP
export const loginUser = async (user, dispatch, navigate, errorCallback) => {
    dispatch(loginStart());
    try {
        const res = await axios.post("/login", user);
        await dispatch(loginSuccess(res.data));
        if (res.data.admin) {
            await navigate("/admin");
        } else {
            await navigate("/");
        }
    }
    catch (error) {
        if (error.response && error.response.data && error.response.data.message !== "") {
            errorCallback(new Error("Sai tên đăng nhập hoặc mật khẩu"));
            dispatch(loginFailed());
        }
    }
}
//ĐĂNG XUẤT
export const logOut = async (dispatch, navigate, accessToken, axiosJWT, refreshToken) => {
    dispatch(logoutStart());
    try {
        await axiosJWT.post(`/logout`, { 'refreshToken': refreshToken }, {
            headers: { token: `Bearer ${accessToken}` },
        });
        dispatch(logoutSuccess());
        dispatch({ type: "RESET_ALL" });      // Reset toàn bộ Redux state
        await persistor.purge();
        navigate("/login");
    }
    catch (err) {
        dispatch(logoutFailed());
    }
}

// CUSTOMER
export const getAllCustomers = async (accessToken, dispatch, axiosJWT) => {
    dispatch(getCustomersStart());
    try {
        const res = await axiosJWT.get(`/customers`, {
            headers: { token: `Bearer ${accessToken}` },
        });
        dispatch(getCustomersSuccess(res.data));
    } catch (err) {
        dispatch(getCustomersFailed());
    }
}

export const getCustomer = async (slug, accessToken, dispatch, axiosJWT) => {
    dispatch(getCustomerStart());
    try {
        const res = await axiosJWT.get(`/customers/${slug}`, {
            headers: { token: `Bearer ${accessToken}` },
        });
        dispatch(getCustomerSuccess(res.data));
    } catch (err) {
        dispatch(getCustomerFailed());
    }
}

export const createCustomer = async (data, accessToken, dispatch, axiosJWT, successCallback, failedCallback) => {
    dispatch(createCustomerStart());
    try {
        const res = await axiosJWT.post(`/customers`, data, {
            headers: {
                token: `Bearer ${accessToken}`,
                'Content-Type': 'multipart/form-data'
            },
        });
        dispatch(createCustomerSuccess(res.data));
        successCallback();
    } catch (err) {
        dispatch(createCustomerFailed());
        failedCallback();
    }
}

export const updateCustomer = async (id, data, accessToken, dispatch, axiosJWT, successCallback, failedCallback) => {
    dispatch(updateCustomerStart());
    try {
        const res = await axiosJWT.put(`/customers/${id}`, data, {
            headers: {
                token: `Bearer ${accessToken}`,
                'Content-Type': 'multipart/form-data'
            },
        });
        dispatch(updateCustomerSuccess(res.data));
        successCallback();
    } catch (err) {
        dispatch(updateCustomerFailed());
        failedCallback();
    }
}

export const deleteCustomer = async (id, accessToken, dispatch, axiosJWT, successCallback, failedCallback) => {
    dispatch(deleteCustomerStart());
    try {
        await axiosJWT.delete(`/customers/${id}`, {
            headers: { token: `Bearer ${accessToken}` },
        });
        dispatch(deleteCustomerSuccess(id));
        successCallback()
    } catch (err) {
        dispatch(deleteCustomerFailed());
        failedCallback()
    }
}

// USERS
export const getUsersOfCustomer = async (slug, accessToken, dispatch, axiosJWT) => {
    dispatch(getUsersStart());
    try {
        const res = await axiosJWT.get(`/customers/${slug}/users`, {
            headers: { token: `Bearer ${accessToken}` },
        });
        dispatch(getUsersSuccess(res.data));
    } catch (err) {
        dispatch(getUsersFailed());
    }
};

export const createUserForCustomer = async (slug, data, accessToken, dispatch, axiosJWT, successCallback, failedCallback) => {
    dispatch(createUserStart());
    try {
        const res = await axiosJWT.post(`/customers/${slug}/users`, data, {
            headers: { token: `Bearer ${accessToken}` },
        });
        dispatch(createUserSuccess(res.data));
        successCallback();
    } catch (err) {
        dispatch(createUserFailed());
        failedCallback();
    }
};

// FACEBOOK
// Liên kết tài khoản facebook
export const loginUserFb = async (accessToken, slug) => {
    const response = await axios.post(`/auth/facebook-auth/${slug}`, { accessToken });
    return (response.data);
}
// Liên kết tài khoản quảng cáo facebook 
export const loginActAdsFb = async (accessToken) => {
    const response = await axios.post(`/auth/facebook-ads-auth`, { accessToken });
    return (response.data);
}
// Lấy data fanpage Fb
export const getDataFacebook = async (slug, accessToken, dispatch, axiosJWT, params = {}) => {
    dispatch(getDataFacebookStart());
    try {
        // params có thể chứa { since: "2025-08-01", until: "2025-08-27" }
        const res = await axiosJWT.get(`/facebook/${slug}/insights`, {
            headers: { token: `Bearer ${accessToken}` },
            params, // append ?since=...&until=...
        });
        dispatch(getDataFacebookSuccess(res.data));
    } catch (err) {
        console.error("getDataFacebook error:", err.response?.data || err.message);
        dispatch(getDataFacebookFailed());
    }
};
// TIKTOK
//Lấy data tiktok cá nhân
export const getDataTiktok = async (slug, accessToken, dispatch, axiosJWT, params) => {
    dispatch(getDataTiktokStart());
    try {
        const res = await axiosJWT.get(`/tiktok/${slug}/insights`, {
            headers: { token: `Bearer ${accessToken}` },
            params,
        });
        dispatch(getDataTiktokSuccess(res.data));
    } catch (err) {
        dispatch(getDataTiktokFailed());
    }
};

// New helpers that also fetch previous-month same-period
export const getDataFacebookWithPrev = async (slug, accessToken, dispatch, axiosJWT, params = {}) => {
    dispatch(getDataFacebookStart());
    try {
        const toDate = (iso) => {
            const [y, m, d] = (iso || "").split("-").map(Number);
            return new Date(y, (m || 1) - 1, d || 1);
        };
        const shiftISO = (iso, deltaDays) => {
            const dt = toDate(iso);
            dt.setDate(dt.getDate() + (deltaDays || 0));
            const mm = String(dt.getMonth() + 1).padStart(2, "0");
            const dd = String(dt.getDate()).padStart(2, "0");
            return `${dt.getFullYear()}-${mm}-${dd}`;
        };
        const daysInMonth = (y, mIndex) => new Date(y, mIndex + 1, 0).getDate();
        const prevMonthSameDayISO = (iso) => {
            const dt = toDate(iso);
            const y = dt.getFullYear();
            const m = dt.getMonth();
            const d = dt.getDate();
            const pm = m - 1;
            const py = pm < 0 ? y - 1 : y;
            const pmi = pm < 0 ? 11 : pm;
            const clamp = Math.min(d, daysInMonth(py, pmi));
            const prev = new Date(py, pmi, clamp);
            const mm = String(prev.getMonth() + 1).padStart(2, "0");
            const dd = String(prev.getDate()).padStart(2, "0");
            return `${prev.getFullYear()}-${mm}-${dd}`;
        };

        const { since, until } = params || {};
        const currentParams = (since && until)
            ? { since: shiftISO(since, -1), until }
            : params;
        const prevParams = (since && until)
            ? { since: shiftISO(prevMonthSameDayISO(since), -1), until: prevMonthSameDayISO(until) }
            : {};
        const [resCur, resPrev] = await Promise.all([
            axiosJWT.get(`/facebook/${slug}/insights`, {
                headers: { token: `Bearer ${accessToken}` },
                params: currentParams,
            }),
            axiosJWT.get(`/facebook/${slug}/insights`, {
                headers: { token: `Bearer ${accessToken}` },
                params: prevParams,
            }),
        ]);

        dispatch(getDataFacebookSuccess({ current: resCur.data, previous: resPrev.data }));
    } catch (err) {
        console.error("getDataFacebookWithPrev error:", err.response?.data || err.message);
        dispatch(getDataFacebookFailed());
    }
};

export const getDataTiktokWithPrev = async (slug, accessToken, dispatch, axiosJWT, params = {}) => {
    dispatch(getDataTiktokStart());
    try {
        const toDateVN = (vn) => {
            const [d, m, y] = (vn || "").split("/").map(Number);
            return new Date(y, (m || 1) - 1, d || 1);
        };
        const fmtVN = (date) => {
            const dd = String(date.getDate()).padStart(2, "0");
            const mm = String(date.getMonth() + 1).padStart(2, "0");
            const yy = date.getFullYear();
            return `${dd}/${mm}/${yy}`;
        };
        const daysInMonth = (y, mIndex) => new Date(y, mIndex + 1, 0).getDate();
        const prevMonthSameDayVN = (vn) => {
            const dt = toDateVN(vn);
            const y = dt.getFullYear();
            const m = dt.getMonth();
            const d = dt.getDate();
            const pm = m - 1;
            const py = pm < 0 ? y - 1 : y;
            const pmi = pm < 0 ? 11 : pm;
            const clamp = Math.min(d, daysInMonth(py, pmi));
            const prev = new Date(py, pmi, clamp);
            return fmtVN(prev);
        };

        const { since, until } = params || {};
        const prevParams = (since && until)
            ? { since: prevMonthSameDayVN(since), until: prevMonthSameDayVN(until) }
            : {};

        const [resCur, resPrev] = await Promise.all([
            axiosJWT.get(`/tiktok/${slug}/insights`, {
                headers: { token: `Bearer ${accessToken}` },
                params,
            }),
            axiosJWT.get(`/tiktok/${slug}/insights`, {
                headers: { token: `Bearer ${accessToken}` },
                params: prevParams,
            }),
        ]);

        dispatch(getDataTiktokSuccess({ current: resCur.data, previous: resPrev.data }));
    } catch (err) {
        console.error("getDataTiktokWithPrev error:", err.response?.data || err.message);
        dispatch(getDataTiktokFailed());
    }
};
